<div class="table-responsive small">
    <p-table [value]="statuses" [loading]="isReportLoading" styleClass="p-datatable-striped" [tableStyle]="{ 'min-width': '50rem' }">
        <ng-template pTemplate="header">
            <tr>
                <th scope="col">Rep</th>
                <th scope="col">Assigned</th>
                <th scope="col">Not Worked</th>
                <th scope="col">Survey Completed</th>
                <th scope="col">Called/Emailed</th>
                <th scope="col">Called</th>
                <th scope="col">Emailed</th>
                <th scope="col">Already Contacted</th>
                <th scope="col">Feedback</th>
                <th scope="col">CC Issue</th>
                <th scope="col">Holding</th>
                <th scope="col">Not Eligible</th>
                <th scope="col">Survey Sent</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-i="rowIndex" , let-m>
            <tr>
                <td><span data-private>{{ m.clientRepName }}</span></td>
                <td>{{ m.assigned }}</td>
                <td>{{ m.notWorked }}</td>
                <td>{{ m.surveyCompleted }}</td>
                <td>{{ m.calledEmailed }}</td>
                <td>{{ m.called }}</td>
                <td>{{ m.emailed }}</td>
                <td>{{ m.alreadyContacted }}</td>
                <td>{{ m.feedback }}</td>
                <td>{{ m.ccIssue }}</td>
                <td>{{ m.holding }}</td>
                <td>{{ m.notEligible }}</td>
                <td>{{ m.surveySent }}</td>
            </tr>
        </ng-template>
    </p-table>
</div>
